module.exports = __webpack_public_path__ + "static/media/books.0336a96b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/books.png
// module id = 115
// module chunks = 0